module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SitePage"
  }, [_c('h2', [_vm._v("Users")]), _vm._v(" "), (_vm.usersList[0] != undefined) ? _c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.usersList), function(userobj) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(userobj.user.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userobj.user.displayname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userobj.user.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userobj.user.admin))]), _vm._v(" "), _c('td', [_c('button', {
      on: {
        "click": function($event) {
          return _vm.grantAdmin(userobj.user.username)
        }
      }
    }, [_vm._v("Grant Admin")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          return _vm.revokeAdmin(userobj.user.username)
        }
      }
    }, [_vm._v("Revoke Admin")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          return _vm.resetPassword(userobj.user.username)
        }
      }
    }, [_vm._v("Reset Password")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          return _vm.deleteUser(userobj.user.username)
        }
      }
    }, [_vm._v("Delete Account")])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.adminResult != '') ? _c('p', [_vm._v(_vm._s(_vm.adminResult))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Username")]), _vm._v(" "), _c('th', [_vm._v("Display name")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Admin?")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7222e516","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/MainAdminPage.vue
// module id = 389
// module chunks = 1